exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expand-transition[data-v-24672bba]{transition:all 2s ease;height:0;opacity:1%}.expand-enter[data-v-24672bba]{height:0;opacity:0}.expand-leave[data-v-24672bba]{height:100%;opacity:1%}", ""]);

// exports
